import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import TrainingType from './Type';
import styles from './styles.less';

const SelectType = ({ setValue, t, translate, trainingTypeOptions, images, selected }) => (
    <div>
        <WizardInput title={t('course.create.wizard.stepType')} hint={t('wizard.hint.type')}>
            {trainingTypeOptions.map((type, index) => (
                <div
                    className={styles.cardOuter}
                    onClick={() => setValue(type, 'trainingType')}
                    key={type.id}
                    name={`wizard_${type.title}`}
                >
                    <TrainingType
                        image={images[index]}
                        text={translate(type, 'title')}
                        description={t(`wizard.${type.title}.description`)}
                        active={selected.title === type.title}
                    />
                </div>
            ))}
        </WizardInput>
    </div>
);

SelectType.propTypes = {
    trainingTypeOptions: PropTypes.array,
    images: PropTypes.array,
    setValue: PropTypes.func,
    t: PropTypes.func,
    translate: PropTypes.func,
    selected: PropTypes.object,
};

SelectType.defaultProps = {
    trainingTypeOptions: [],
    images: [],
    setValue: () => {},
    t: () => {},
    translate: () => {},
    selected: {},
};

export default SelectType;
